// @flow
/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

import React, { Component } from 'react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import SecurityRulesConfigureRules from './Izenda.SecurityRulesConfigureRules';
import SecurityRulesDataSources from './Izenda.SecurityRulesDataSources';
import SecurityRulesFields from './Izenda.SecurityRulesFields';
import connect from 'share/enhancers/Izenda.Connect';
import { isEmpty } from 'lodash/fp';

class SecurityRulesPopup extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      props: { 
        localization, onReject, onAccept,
        rulesSet, onSecurityRulesSetSave,
        store, confirmFn, validation,
        store: {
          model
        }
      }
    } = this;

    const saveSelectedQuerySourceFields = () => {
      const selectedQuerySourceFields = model.getSelectedQuerySourceFields();
      rulesSet.updateFields(selectedQuerySourceFields);
    }

    const goToNextStep = () => {
      const nextStep = model.rowLevelSecurityStepNumber + 1;
      if(nextStep === 2){
        const selectedQuerySourceIds = model.getSelectedQuerySourceIds();
        if(isEmpty(selectedQuerySourceIds)){
          confirmFn('warning', {
            type: 'warning',
            description: localization.getText('SECURITY_RULES_MESSAGE_DATA_SOURCES_NOT_SELECTED'),
            showCancel: false
          });
        }else{
          store.getConnectionDetailInfoByQuerySoures({querySourceIds: selectedQuerySourceIds})
          .then(result => {
            model.populateFieldQuerySourceTree(result, rulesSet);
            model.rowLevelSecurityStepNumber = nextStep;
            return null;
          });
        }
      }else{
        saveSelectedQuerySourceFields();
        if(isEmpty(rulesSet.fields)){
          confirmFn('warning', {
            type: 'warning',
            description: localization.getText('SECURITY_RULES_MESSAGE_FIELDS_NOT_SELECTED'),
            showCancel: false
          });
        }else{
          model.rowLevelSecurityStepNumber = nextStep;
        }
      }
    }

    const goToPreviousStep = () => {
      const previousStep = model.rowLevelSecurityStepNumber - 1;
      if(previousStep === 1){
        saveSelectedQuerySourceFields();
      }
      model.rowLevelSecurityStepNumber = previousStep;
    }

    const onClosing = (callback, type) => {
      if(type === 'accept'){
        if(isEmpty(rulesSet.rules)){
          confirmFn('warning', {
            type: 'warning',
            description: localization.getText('SECURITY_RULES_MESSAGE_RULES_NOT_CREATED'),
            showCancel: false
          });
        }else{
          validation.validate()
          .then(isValidated => {
            if(isValidated){
              confirmFn('Confirmation', {
                description: localization.getText('SECURITY_RULES_MESSAGE_CONFIRM_SAVING')
              })
              .then(() => {
                onSecurityRulesSetSave(rulesSet);
                onAccept();
                return null;
              });
            }
            return null;
          });
        }
      }else{
        onReject();
      }
    };

    let title = '';
    switch(model.rowLevelSecurityStepNumber){
      case 1:
        title = localization.getText('SECURITY_RULES_POPUP_TITLE_FIRST_STEP');
        break;
      case 2:
        title = localization.getText('SECURITY_RULES_POPUP_TITLE_SECOND_STEP');
        break;
      case 3:
        title = localization.getText('SECURITY_RULES_POPUP_TITLE_THIRD_STEP');
      break;
    }

    return (
      <Popup visible onClosing={onClosing} autoClose={false} type="none" sizeClass="modal-lg">
        <Popup.Header title={title} />
        <Popup.Body>
          <div>
            {model.rowLevelSecurityStepNumber === 1 && (<SecurityRulesDataSources store={store} />)}
            {model.rowLevelSecurityStepNumber === 2 && (<SecurityRulesFields store={store} />)}
            {model.rowLevelSecurityStepNumber === 3 && (<SecurityRulesConfigureRules rulesSet={rulesSet}  store={store} />)}
          </div>
        </Popup.Body>
        <Popup.Footer>
          {
            model.rowLevelSecurityStepNumber > 1 && 
            (<Popup.ConfirmationButton onClick={goToPreviousStep} type="custom" className="btn-report-default">{localization.getText('COMMON_LABEL_BACK')}</Popup.ConfirmationButton>)
          }
          {
            model.rowLevelSecurityStepNumber < 3 && 
            (<Popup.ConfirmationButton onClick={goToNextStep} type="custom">{localization.getText('COMMON_LABEL_NEXT')}</Popup.ConfirmationButton>)
          }
          {
            model.rowLevelSecurityStepNumber === 3 &&
            (<Popup.ConfirmationButton type="cancel">{localization.getText('COMMON_LABEL_CANCEL')}</Popup.ConfirmationButton>)
          }
          {
            model.rowLevelSecurityStepNumber === 3 &&
            (<Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_SAVE')}</Popup.ConfirmationButton>)
          }
        </Popup.Footer>
      </Popup>
    );
  }
}

const popupWindow = connect()(SecurityRulesPopup);
popupWindow.displayName  = 'SecurityRulesPopup';
export default popupWindow;




// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/SecurityRules/Izenda.SecurityRulesPopup.jsx